import { Routes } from '@angular/router';
import { canActivateAuthRole } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'patients', pathMatch: 'full' },
  {
    path: 'patients',
    loadChildren: () =>
      import('./modules/patients/patients.routes').then(
        (m) => m.PATIENTS_ROUTES
      ),
      canActivate: [canActivateAuthRole],
      data: { role: 'patient' }
  },
  {
    path: 'doctors',
    loadChildren: () =>
      import('./modules/doctors/doctors.routes').then(
        (m) => m.DOCTORS_ROUTES
      ),
      canActivate: [canActivateAuthRole],
      data: { role: 'doctor' }
  },
  {
    path: 'administrator',
    loadChildren: () =>
      import('./modules/administrator/administrator.routes').then(
        (m) => m.ADMINISTRATOR_ROUTES
      ),
      canActivate: [canActivateAuthRole],
      data: { role: 'administrator' }
  },
  { path: '**', redirectTo: 'patients' },
];
